export default {
  getMusics(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/repertories/musics?limit=${data.limit}&themes__in=${data.idsThemes}&exclude=${data.idsMusics}&type__in=${data.typesToFilter}&name__icontains=${data.textToFilter}&intensity__in=${data.idsIntensities}&name__startswith__in=${data.letters}&order_by=${data.order_by}`
        )
        .then(response => {
          context.commit("setMusics", response.data.results);
          context.commit("setCountMusics", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  createNewRepertory(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/repertories/add-myrepertory", data)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  getRepertories(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/repertories/myrepertories?user=${data.id}`)
        .then(response => {
          context.commit("setRepertories", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  updateMyRepertory(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/repertories/update-myrepertory", data)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  getThemesToFilter(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/repertories/themes?limit=9999")
        .then(response => {
          context.commit("setThemes", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  deleteMyRepertory(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/repertories/delete-myrepertory/${id}`)
        .then(function(response) {
          resolve(response);
        })
        .catch(reject);
    });
  },

  getPDF(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/repertories/pdf-repertory/${id}`, {
          responseType: "arraybuffer"
        })
        .then(response => {
          resolve(response);
        })
        .catch(reject);
    });
  }
};
